import React from 'react';
import './BlurringOverlay.css';
import { LockFilled } from '@ant-design/icons';
import { useEvent } from '../../features/events/hooks/useEvent';
import { useNavigate } from 'react-router-dom';
import { UserRole } from '../../features/PrerenderUser';
import ButtonWithRole from '../ButtonWithRole';
import { usePrerenderUserId } from '../../hooks/usePrerenderUser';
import { isUserTestingGroupA } from '../../features/OnboardingSurvey';

type BlurringOverlayProps = {
  content?: string;
  enabled: boolean;
  location?: string;
  buttonData?: {
    title: string;
    onClick: () => void;
    url?: string;
  } | null;
  blurringRadius?: number;
  opacity?: number;
  showButton?: boolean;
};

export const BlurringOverlay = ({
  content,
  enabled,
  location,
  buttonData,
  blurringRadius = 3,
  opacity,
  showButton = true,
}: BlurringOverlayProps) => {
  const { track } = useEvent();
  const navigate = useNavigate();
  const userId = usePrerenderUserId();

  const handleOnClick = () => {
    navigate('/integration-wizard');
    track('Integration Started', {
      location: location,
      ABTesting: isUserTestingGroupA(userId) ? 'Group A' : 'Group B',
    });
  };

  if (!enabled) return <></>;

  return (
    <div
      className="blurring-overlay"
      style={{
        backdropFilter: `blur(${blurringRadius}px)`,
        background: opacity ? `rgba(255, 255, 255, ${opacity})` : '',
      }}
    >
      {content && (
        <div className="blurring-content">
          <LockFilled style={{ color: '#BECAE1' }} />
          <p className="content-text">{content}</p>
          {showButton && (
            <ButtonWithRole
              disabledFor={[UserRole.Guest]}
              className="content-link"
              type="primary"
              onClick={buttonData?.onClick ? buttonData.onClick : handleOnClick}
              href={buttonData?.url}
              target="_blank"
            >
              {buttonData?.title || 'Start Integration'}
            </ButtonWithRole>
          )}
        </div>
      )}
    </div>
  );
};
